
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/login",
      function () {
        return require("private-next-pages/[id]/login.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/login"])
      });
    }
  